export const authorizedHi: string[] = [
  "अंबाला",
  "अम्बाला-I"
]
